import React from "react";
import {StyledATag} from "./styles";
import PropTypes from 'prop-types'

export const DocumentationEmail =({text, styleEmail}) => {
  
    const textArray = text.split(styleEmail)
    
    return(
        <span>
            {textArray.map((item,index) => (
                <>
                {item.split('"')}
                {index !== textArray.length-1 && (
                    <StyledATag href="mailto:Interoperability@Healthfirst.org">{styleEmail}</StyledATag>
                )}
                </>
            ))}
        </span>
    )
}

DocumentationEmail.propTypes = {
    text: PropTypes.string.isRequired,
    styleEmail: PropTypes.string.isRequired,
}

export default DocumentationEmail;